import React from 'react'

import MenuBookIcon from '@mui/icons-material/MenuBook'

import { TerminologyCardStyle } from '../styles'
import TerminologyViewModal from '../modals/TerminologyViewModal'
import TerminologyRevisionModal from '../modals/TerminologyRevisionModal'
import ResourceCard from './ResourceCard'
import ViewSourcesButton from '../shared/ViewSourcesButton'
import { safeHref } from '../../utils/safeUrl'

const TerminologyCard = (props) => {

    const extraActions = <TerminologyRevisionModal {...props} />
    const sources = props.sources || []
    const hasLinkedSource = sources.some(s => s && safeHref(s.url))

    return (
        <ResourceCard
            Icon={MenuBookIcon}
            cardStyle={TerminologyCardStyle}
            modal={<TerminologyViewModal {...props} />}
            title={props.term}
            date={props.updated.split('T')[0]}
            dateLabel='Updated:'
            showButton={false}
            viewControl={hasLinkedSource
                ? ({ buttonProps, sx }) => (
                    <ViewSourcesButton
                        sources={sources}
                        buttonProps={buttonProps}
                        sx={sx}
                    />
                )
                : undefined}
            mobileExtraActions={extraActions}
            desktopExtraActions={extraActions}
        />
    )
}

export default TerminologyCard
